module.exports = __webpack_public_path__ + "images/how-can-pipeline-help.png";